import React from "react";

import {CircularProgress, Stack} from "@mui/joy";
import Chip from "@mui/joy/Chip";

// components
import BaseApi from "../../utils/BaseApi";
import OpportunityCard from "../Cards/OpportunityCard";


class OpportunityTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opportunities: null,
        };
    }

    async componentDidMount() {
        await this.retrieveOpportunities();
    }

    async retrieveOpportunities() {
        const url = `opportunity/`;
        const api = new BaseApi();
        let params = {
            page_size: 10000,
        }
        if (this.props.accountId){
            params.account = this.props.accountId
        }
        let response = await api.get(
            url,
            params
        );
        this.setState(
            {
                opportunities: response.data.results
            }
        );
    }

    render() {
        if (!this.state.opportunities) {
            return (<CircularProgress/>)
        }
        return (
            <Stack
                spacing={2}
            >
                <Chip
                    color={'primary'}
                >
                    В работе
                </Chip>
                {this.state.opportunities.filter((o) => o.status === 'OPENX').map((each) => (
                    <OpportunityCard
                        showStatus={true}
                        opportunityID={each.id}
                    />
                ))}
                <Chip
                    color={'warning'}
                >
                    Ожидание
                </Chip>
                {this.state.opportunities.filter((o) => o.status === 'DELAY').map((each) => (
                    <OpportunityCard
                        showStatus={true}
                        opportunityID={each.id}
                    />
                ))}
                <Chip
                    color={'success'}
                >
                    Закрытые успешно
                </Chip>
                {this.state.opportunities.filter((o) => o.status === 'CLOSE').map((each) => (
                    <OpportunityCard
                        showStatus={true}
                        opportunityID={each.id}
                    />
                ))}
                <Chip
                    color={'danger'}
                >
                    Потерянные
                </Chip>
                {this.state.opportunities.filter((o) => o.status === 'LOSTX').map((each) => (
                    <OpportunityCard
                        showStatus={true}
                        opportunityID={each.id}
                    />
                ))}
            </Stack>
        )
    }
}

export default OpportunityTab
